"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var CheckmarkPolygonOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_CheckmarkPolygonOutline_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.874 6.332a.5.5 0 1 0-.748-.664L7.48 9.77 5.354 7.646a.5.5 0 1 0-.708.708l2.5 2.5a.5.5 0 0 0 .728-.022l4-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m8 0 2.342 2.346 3.315-.003-.003 3.315L16 8l-2.346 2.342.003 3.315-3.315-.003L8 16l-2.342-2.346-3.315.003.003-3.315L0 8l2.346-2.342-.003-3.315 3.315.003L8 0Zm2.343 3.346 2.313-.002-.002 2.313a1 1 0 0 0 .294.709L14.585 8l-1.637 1.634a1 1 0 0 0-.294.709l.002 2.313-2.313-.002a1 1 0 0 0-.709.294L8 14.585l-1.634-1.637a1 1 0 0 0-.709-.294l-2.313.002.002-2.313a1 1 0 0 0-.294-.709L1.415 8l1.637-1.634a1 1 0 0 0 .294-.709l-.002-2.313 2.313.002a1 1 0 0 0 .709-.294L8 1.415l1.634 1.637a1 1 0 0 0 .709.294Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_CheckmarkPolygonOutline_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = CheckmarkPolygonOutline;
exports["default"] = _default;